import { render, staticRenderFns } from "./SP.vue?vue&type=template&id=05990c94&scoped=true&"
import script from "./SP.vue?vue&type=script&lang=js&"
export * from "./SP.vue?vue&type=script&lang=js&"
import style0 from "./SP.vue?vue&type=style&index=0&id=05990c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05990c94",
  null
  
)

export default component.exports